import DataSource from "../DataSource/DataSource";

export default class KontaktService {
  constructor(server){
    this.server = server;
  }
 
  listSource(config = {}){
    return new DataSource(this.server, "kontakt.list.source", {limit: config.limit || 10})
  }

  get(id){
    return this.server("kontakt.get", {id: id});
  }

  save(id, customer){
    return this.server("kontakt.update", {id: id, data: customer});
  }

  importARES(ics){
    return this.server("kontakt.ares", {ics: ics});
  }

  importSource(){
    return new DataSource(this.server, "kontakt.import.source", {limit: 15});
  }

  importConfirm(ids){
    return this.server("kontakt.import.confirm", {ids: ids});
  }

  importCancel(ids){
    return this.server("kontakt.import.cancel", {ids: ids});
  }

}


// WEBPACK FOOTER //
// ./src/Kontakt/KontaktService.js